import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import CommentIndicatorOverlay from './CommentIndicatorOverlay';

const CommentIndicatorWrapper = ({ getNavigatorChart, comments: initialComments }) => {
  const [dimensions, setDimensions] = useState({
    width: 0,
    left: 0,
    top: 0,
    min: null,
    max: null
  });
  const [comments, setComments] = useState(initialComments || []);
  const [commentsLoaded, setCommentsLoaded] = useState(false);
  const updateTimeoutRef = useRef(null);

  const updateDimensions = () => {
    // Debounce updates
    if (updateTimeoutRef.current) {
      clearTimeout(updateTimeoutRef.current);
    }
    
    updateTimeoutRef.current = setTimeout(() => {
      const navChart = getNavigatorChart();
      
      if (navChart && navChart.navigator) {
        const navigator = navChart.navigator;
        
        // Check if navigator is rendered
        if (navigator.rendered && navigator.navigatorGroup) {
          const navigatorGroup = navigator.navigatorGroup;
          const bbox = navigatorGroup.getBBox();
          
          // Get the navigator's own xAxis (not the main chart's xAxis)
          const xAxis = navigator.xAxis;
          
          
          setDimensions(prev => {
            // Only update if changed
            if (prev.width === bbox.width && 
                prev.left === bbox.x && 
                prev.top === bbox.y &&
                prev.min === xAxis.min && 
                prev.max === xAxis.max) {
              return prev;
            }
            
            return {
              width: bbox.width,
              left: bbox.x,
              top: bbox.y,
              min: xAxis.min,
              max: xAxis.max
            };
          });
        }
      }
    }, 200); // Debounce by 200ms
  };

  useEffect(() => {
    // Initial update - wait longer for navigator to render
    const timer = setTimeout(updateDimensions, 1000);
    
    // Listen for navigator changes
    const handleExtremesChange = (e) => {
      updateDimensions();
    };
    
    const handleResize = () => {
      updateDimensions();
    };
    
    const handleCommentsLoaded = (event) => {
      if (event.detail && event.detail.comments) {
        setComments(event.detail.comments);
      }
      setCommentsLoaded(true);
      updateDimensions();
    };
    
    window.addEventListener('navigator-extremes-changed', handleExtremesChange);
    window.addEventListener('resize', handleResize);
    window.addEventListener('navigator-comments-loaded', handleCommentsLoaded);
    
    return () => {
      clearTimeout(timer);
      if (updateTimeoutRef.current) {
        clearTimeout(updateTimeoutRef.current);
      }
      window.removeEventListener('navigator-extremes-changed', handleExtremesChange);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('navigator-comments-loaded', handleCommentsLoaded);
    };
  }, []);


  return (
    <CommentIndicatorOverlay
      comments={comments}
      navigatorMin={dimensions.min}
      navigatorMax={dimensions.max}
      navigatorWidth={dimensions.width}
      navigatorLeft={dimensions.left}
      navigatorTop={dimensions.top}
      isVisible={comments && comments.length > 0}
    />
  );
};

export default CommentIndicatorWrapper;